// extracted by mini-css-extract-plugin
export default {"input":"List_input__iPRok","generateButton":"List_generateButton__PIEpG","printButton":"List_printButton__vxNrX","qrContainer":"List_qrContainer__BxrZS"};